import React from 'react';

// Footer component without newsletter subscription

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold text-blue-300 mb-4">Cokes LLC- ShourShivKrish Band</h3>
            <p className="text-gray-400 mb-6">
              Three 9-year-old musical prodigies bringing joy through music.
            </p>

          </div>
          
          <div className="md:justify-self-end md:text-right">
            <h3 className="text-lg font-semibold text-blue-300 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-400 hover:text-blue-300 transition-colors duration-300">Home</a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-blue-300 transition-colors duration-300">About</a>
              </li>
              <li>
                <a href="#music" className="text-gray-400 hover:text-blue-300 transition-colors duration-300">Music</a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-blue-300 transition-colors duration-300">Contact</a>
              </li>
            </ul>
          </div>
          
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            &copy; 2023 Cokes LLC- ShourShivKrish Band. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
